import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/software/pos")({
  component: () => <Outlet />,
});
